import React from 'react'
import HeroSection from './components/HeroSection';
import FiveYears from './components/FiveYears';
import OfferSection from './components/OfferSection';
import ProcessSection from './components/ProcessSection';
import TaglineSection from './components/TaglineSection';
import TestimonialSection from './components/TestimonialSection';
import JoinUsSection from './components/JoinUsSection';
import EventsVarieties from './components/EventVarieties';
import Organisations from './components/Organisations';
import EventHostSection from './components/EventHostSection';
import ContactSection from './components/ContactSection';



const EventsCollaborateLandingPage = () => {
  return (
    <>
      <HeroSection />
      <FiveYears />
      <OfferSection />
      <ProcessSection />
      <TaglineSection />
      <TestimonialSection />
      <JoinUsSection />
      <EventsVarieties />
      <Organisations />
      <EventHostSection />
      <ContactSection />
    </>
  )
}

export default EventsCollaborateLandingPage;